<template>
  <div class="container mt-4">
    <!-- Prompt Area -->
    <div class="card mb-3">
      <div class="card-header">
        <h5 class="mb-0">Programming Language</h5>
      </div>
      <div class="card-body">

        <div class="row g-2 align-items-center">
          <div class="col-md-3">
            <label class="form-label mb-0">Language</label>
            <select v-model="selectedLanguage" class="form-select">
              <option v-for="lang in languages" :key="lang" :value="lang">{{ lang }}</option>
              <option value="Other">Other...</option>
            </select>
            <input v-if="selectedLanguage === 'Other'" v-model="customLanguage" type="text" class="form-control mt-2"
              placeholder="Enter language">
          </div>
          <div class="col-md-3">
            <label class="form-label mb-0">API Feature</label>
            <select v-model="selectedFeature" class="form-select">
              <option v-for="feature in apiFeatures" :key="feature" :value="feature">{{ feature }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label mb-0">API Key</label>
            <input v-model="apiKey" type="text" class="form-control" placeholder="e.g. YOUR_API_KEY"
              @keydown.enter.prevent>
            <small class="text-muted">Sign in to see your API key.</small>
          </div>
        </div>
      </div>
    </div>
  
  <!--
          <div class="row g-2 mt-3">
            <div class="col-md-4">
              <label class="form-label mb-0">Location(s)</label>
              <input v-model="location" type="text" class="form-control" placeholder="e.g. New York, London" @keydown.enter.prevent>
            </div>
            <div class="col-md-4">
              <label class="form-label mb-0">Start Date</label>
              <input v-model="startDate" type="date" class="form-control" @keydown.enter.prevent>
            </div>
            <div class="col-md-4">
              <label class="form-label mb-0">End Date</label>
              <input v-model="endDate" type="date" class="form-control" @keydown.enter.prevent>
            </div>
          </div>
        -->
  <!-- Locations Editor -->
  <div class="card mb-2">
    <div class="card-header">
      <h5 class="mb-0">Locations</h5>
    </div>
    <div class="card-body">
      <LocationsEditor :parentLocations="currentPackage.locations || []" :sessionState="sessionState"
        @update:locations="updateLocations" />
    </div>
  </div>


  <!-- Data options for all goals -->
  <div class="card mb-2">
    <div class="card-header">
      <h5 class="mb-0">Date Range and Data Options</h5>
    </div>
    <div class="card-body">

      <div class="row g-2">
        <div class="col-md-4">
          <label class="form-label mb-0">Date Range</label>
          <DateRangeChooser class="" :queryDefinition="currentPackage.params" @change:daterange="setDateRange">
          </DateRangeChooser>
        </div>

        <div class="col-md-4">
          <label class="form-label mb-0">Unit group</label>
          <div>
            <button class="dropdown-toggle btn text-primary px-1" type="button" id="unitGroupDropdownButton"
              data-bs-toggle="dropdown" aria-expanded="false">
              <span class="d-none d-md-inline" v-html="getUnitGroupLabel(queryDefn.unitGroup, false)" />
              <span class="d-inline d-md-none" v-html="getUnitGroupLabel(queryDefn.unitGroup, true)" />
            </button>
        
            <ul class="dropdown-menu" aria-labelledby="unitGroupDropdownButton">
              <li v-for="u in unitGroups">
                <a class="dropdown-item" href="#" @click.prevent="setUnitGroup(u.id)"><span class="d-none d-md-inline"
                    v-html="u.label"></span><span class="d-inline d-md-none" v-html="u.shortlabel"></span></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-4">
          
          <button type="button" class="btn btn-sm btn-outline-primary" @click="showTimelineQueryEditor = true">
            <i class="bi bi-bell me-1"></i>
            Advanced options
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card mb-2">
    <div class="card-header">
      <h5 class="mb-0">Weather API Code Generation Prompt</h5>
    </div>
    <div class="card-body">
      
      <form @submit.prevent="sendMessage">
        <div class="">
         
          <textarea v-model="userPrompt" class="form-control mb-2" rows="5" @keydown.enter.prevent></textarea>
          <small class="text-muted">This prompt is auto-generated and editable.</small>
        </div>
        <div class="mt-2 text-end">
          <button class="btn btn-primary" type="submit" :disabled="isThinking">
            <span v-if="!isThinking">Generate Code Sample</span>
            <span v-else>
              <span class="spinner-border spinner-border-sm me-1"></span>
              Processing...
            </span>
          </button>
          <button class="btn btn-outline-secondary ms-2" type="button" @click="clearThread"
            :disabled="isThinking || !threadId">
            <i class="bi bi-trash"></i> Clear
          </button>
        </div>
      </form>
    </div>
        <!-- Timeline Query Editor Modal -->
    <TimelineQueryEditor
        v-if="showTimelineQueryEditor"
        :show="showTimelineQueryEditor"
        :queryDefinition="currentPackage.params || {}"
        @save="updateQueryDefn"
        @cancel="showTimelineQueryEditor = false"
      />
  </div>




  <!-- Results Area -->
  <!-- Only show the latest code sample by default -->
  <div v-if="messages.length" class="mb-3" ref="resultSection">
    <div v-if="latestAssistantMsg" class="card mb-2">
      <div class="card-header d-flex justify-content-between align-items-center">
        <span>
          <i class="bi bi-code-slash me-2"></i>
          {{ latestAssistantMsg.language || selectedLanguage }}
          <span class="badge bg-primary ms-2">Code Sample</span>
        </span>
        <button v-if="latestAssistantMsg.code" class="btn btn-outline-primary btn-sm"
          @click="copyToClipboard(latestAssistantMsg.code)">
          <i class="bi bi-clipboard"></i> Copy
        </button>
      </div>
      <div class="card-body">
        <div v-if="latestAssistantMsg.code">
          <pre><code :class="'language-' + (latestAssistantMsg.language || selectedLanguage)">{{ latestAssistantMsg.code }}</code></pre>
          <div v-if="latestAssistantMsg.sources && latestAssistantMsg.sources.length" class="mt-2">
            <small class="text-muted">Sources:</small>
            <ul>
              <li v-for="src in latestAssistantMsg.sources" :key="src.url">
                <a :href="src.url" target="_blank">{{ src.title || src.filename }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div v-else>
          <div class="formatted-content" v-html="latestAssistantMsg.content"></div>
        </div>
      </div>
    </div>
    <!-- Button to show/hide previous answers -->
    <button v-if="olderAssistantMsgs.length" class="btn btn-link mb-2" @click="showOlder = !showOlder">
      {{ showOlder ? 'Hide' : 'Show' }} previous answers ({{ olderAssistantMsgs.length }})
    </button>
    <div v-if="showOlder">
      <div v-for="(msg, idx) in olderAssistantMsgs" :key="idx" class="card mb-2">
        <!-- ...same code sample display as above, but for msg... -->
        <div class="card-header d-flex justify-content-between align-items-center">
          <span>
            <i class="bi bi-code-slash me-2"></i>
            {{ msg.language || selectedLanguage }}
            <span class="badge bg-primary ms-2">Code Sample</span>
          </span>
          <button v-if="msg.code" class="btn btn-outline-primary btn-sm" @click="copyToClipboard(msg.code)">
            <i class="bi bi-clipboard"></i> Copy
          </button>
        </div>
        <div class="card-body">
          <div v-if="msg.code">
            <pre><code :class="'language-' + (msg.language || selectedLanguage)">{{ msg.code }}</code></pre>
          </div>
          <div v-else>
            <div class="formatted-content" v-html="msg.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Paste Raw Response for Testing -->
  <!--
    <div class="card mb-3">
      <div class="card-body">
        <label class="form-label">Paste Raw Assistant Response</label>
        <textarea v-model="rawPaste" class="form-control mb-2" rows="4" placeholder="Paste raw main_answer value here"></textarea>
        <button class="btn btn-outline-primary" @click="parseRawPaste">Parse & Display</button>
      </div>
    </div>
    -->
  </div>
</template>

<script>

import LocationsEditor from '../LocationsEditor.vue';
import DateRangeChooser from '../DateRangeChooser.vue';
import TimelineQueryEditor from '../TimelineQueryEditor.vue';
import websiteFiles from '@/utils/website_files_dictionary.js';
import { VcConversion } from "/src/visualcrossing-core/vcconversion";
import "/src/visualcrossing-core/vccommunicator_account";
export default {
  name: 'AiApiAssistant',
  components: {

    LocationsEditor,
    DateRangeChooser,
    TimelineQueryEditor,
  },
  data() {
    return {
      unitGroups: VcConversion.UNITGROUPS,
      userPrompt: '',
      selectedLanguage: 'Python',
      customLanguage: '',
      selectedFeature: 'Fetch Timeline Data',
      parameters: '',
      location: '',
      startDate: '',
      endDate: '',
      languages: ['Python', 'JavaScript', 'Java', 'C#', 'PHP', 'R', 'Go', 'Ruby'],
      apiFeatures: [
        'Fetch Timeline Data',
        'Get Forecast',
        'Download CSV',
        'Get Historical Data',
        'Weather Alerts',
        'Bulk Data Request'
      ],
      messages: [],
      threadId: null,
      isThinking: false,
      apiKey: (this.sessionState && this.sessionState.apiKey) || "",
      rawPaste: '',
      showOlder: false,
       showTimelineQueryEditor: false,
      currentPackage: {
        params: {
          "goal": null,
          "startdate": null,
          "enddate": null,
          "unitGroup": "metric",
          "contentType": "json",
          "options": "",
          "include": "",
        },
        locations: [],
        notificationConfigs: [],
        runOnce: true,
        enabled: true,
        runTimes: [],
        type: 4,
        accountUserId: null
      },
    };
  },
  props: {
    sessionId: String,
    sessionState: Object,
  },
  computed: {
    vcCommunicator() {
      return window.vcCommunicator || null;
    },
    latestAssistantMsg() {
    // Find the last assistant message in the array
      for (let i = this.messages.length - 1; i >= 0; i--) {
        if (this.messages[i].role === 'assistant') return this.messages[i];
      }
      return null;
    },
    isOptional() {
      // Check if the latest assistant message is optional
      const latestMsg = this.latestAssistantMsg;
      return latestMsg && latestMsg.content.includes('[OPTIONAL]');
    },
    olderAssistantMsgs() {
      // All previous assistant messages except the latest
      const assistants = this.messages.filter(msg => msg.role === 'assistant');
      return assistants.length > 1 ? assistants.slice(0, assistants.length - 1) : [];
    },
    queryDefn() {
      return this.currentPackage.params || {};
    },
  },
  watch: {
    sessionState(newState) {
      if (newState && newState.apiKey) {
        this.apiKey = newState.apiKey;
      } else {
        this.apiKey = '';
      }
      this.updatePrompt();
    },
    selectedLanguage: 'updatePrompt',
    customLanguage: 'updatePrompt',
    selectedFeature: 'updatePrompt',
    parameters: 'updatePrompt',
    //location: 'updatePrompt',
    //startDate: 'updatePrompt',
    //endDate: 'updatePrompt',
    apiKey: 'updatePrompt',
    currentPackage: {
      handler(newVal) {
       this.updatePrompt();
      },
      deep: true
    }
  },
  methods: {
    updateQueryDefn(defn) {
      Object.assign(this.currentPackage.params, defn);
      this.showTimelineQueryEditor = false;
    },
    setUnitGroup(id) {
      var me=this;
      me.queryDefn.unitGroup=id;
     
      
    },
    getUnitGroupLabel(id, short) {
      var unitGroup = this.unitGroups.reduce(function (a, d) {
        return a || (d.id === id && d);
      }, null);
      return (unitGroup && short ? unitGroup.shortlabel : unitGroup.label) || "-";
    },
    updateLocations(locations) {
      this.currentPackage.locations = locations;
    },
    setDateRange(startPeriod, endPeriod) {

      let me = this;

      me.queryDefn.startdate = startPeriod;
      me.queryDefn.enddate = endPeriod;
      //console.log("Set date range:"+defn.startdate +"=> "+defn.enddate);

    },
    clearThread() {
      if (confirm('Are you sure you want to clear this conversation?')) {
        this.threadId = null;
        this.messages = [];
      }
    },
    async sendMessage() {
      const prompt = this.generatePrompt(this.userPrompt);
      if (!prompt) return;

      if (!this.vcCommunicator) {
        console.error('VcCommunicator not available');
        return;
      }

      this.messages.push({ role: 'user', content: prompt, language: this.selectedLanguage });
      this.isThinking = true;

      try {
        // Send message through VcCommunicator
        const messageData = await this.vcCommunicator.sendaimessage(this.threadId || '', prompt);

        if (messageData.errorCode) {
          throw new Error(messageData.message || 'Failed to send message');
        }

        this.threadId = messageData.thread_id;
        const runId = messageData.id;

        // Poll for completion
        const response = await this.pollForCompletion(runId);

        // Detect language from response
        let detectedLanguage = this.selectedLanguage;
        if (response.language) {
          detectedLanguage = response.language;
        } else {
          const langMatch = response.main_answer.match(/```(\w+)/);
          if (langMatch && langMatch[1]) {
            detectedLanguage = langMatch[1];
          }
        }

        // Extract code block using detected language
        const codeBlock = this.extractCodeBlock(response.main_answer, detectedLanguage);

        this.messages.push({
          role: 'assistant',
          code: codeBlock,
          language: detectedLanguage,
          sources: response.sources || [],
          content: response.main_answer
        });
      } catch (e) {
        console.error(e);
        this.messages.push({
          role: 'assistant',
          content: 'An error occurred: ' + e.message,
          language: this.selectedLanguage,
          code: '',
          sources: []
        });
      } finally {
        this.isThinking = false;
        this.$nextTick(() => {
          const el = this.$refs.resultSection;
          if (el && typeof el.scrollIntoView === 'function') {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    },
    generatePrompt(extraInstructions = '') {
      let lang = this.selectedLanguage === 'Other' ? this.customLanguage : this.selectedLanguage;
      let prompt = `Generate a code sample in ${lang} using the Visual Crossing Weather API. `;
      const locationsArr = this.currentPackage.locations;
      let locationList = [];
      if (locationsArr && locationsArr.length > 0) {
        locationList = locationsArr.map(locObj => locObj.location).filter(Boolean);
        if (locationList.length > 1) {
          prompt += `Use the timelinemulti endpoint for multiple locations. Locations: ${locationList.join(", ")}. `;
        } else if (locationList.length === 1) {
          prompt += `Location: ${locationList[0]}. `;
        }
      }
      if (this.selectedFeature) {
        prompt += `The sample should demonstrate how to "${this.selectedFeature}". `;
      }
      if (this.queryDefn.startdate) {
        prompt += `\nStart date: ${this.currentPackage.params.startdate}. `;
      }
      if (this.queryDefn.enddate) {
        prompt += `End date: ${this.currentPackage.params.enddate}. `;
      }
      if (this.queryDefn.unitGroup) {
        prompt += `\nUnit group: ${this.queryDefn.unitGroup}. `;
      }
       // Add any other properties from queryDefn not already included
      const usedProps = ['startdate', 'enddate', 'unitGroup'];

      let hasAdvancedOptions=false
      Object.keys(this.queryDefn).forEach(key => {
        if (!usedProps.includes(key) && this.queryDefn[key] !== null && this.queryDefn[key] !== '') {
          if (!hasAdvancedOptions) {
            prompt += '\nAdvanced options: ';
            hasAdvancedOptions = true;
          }
          prompt += `'${key}':'${this.queryDefn[key]}'. `;
        }
      });

      if (this.apiKey) {
        prompt += `\nAPI Key: ${this.apiKey}. `;
      }
      if (this.parameters) {
        prompt += `Use these parameters: ${this.parameters}. `;
      }
      if (extraInstructions && extraInstructions !== prompt.trim()) {
        prompt += `Additional instructions: ${extraInstructions}`;
      }

      prompt += '\n\nEnsure that the code is well-commented and includes error handling. If an HTTP status code other than 200 is returned, ensure the result body is returned for additional error information.' +
        'The code should be ready to run without additional modifications. ';
      
      return prompt.trim();
    },

  updatePrompt() {
    this.userPrompt = this.generatePrompt();
  },
    async pollForCompletion(runId) {
      while (true) {
        const runStatus = await this.vcCommunicator.getairunstatus(this.threadId, runId);

        if (runStatus.errorCode) {
          throw new Error(runStatus.message || 'Failed to get run status');
        }

        if (runStatus.status === 'completed') break;
        if (runStatus.status === 'failed') throw new Error('Assistant run failed');

        await new Promise((resolve) => setTimeout(resolve, 3000));
      }

      // Get messages
      const msgData = await this.vcCommunicator.getaimessages(this.threadId, null);

      if (msgData.errorCode) {
        throw new Error(msgData.message || 'Failed to get messages');
      }

      // Find the latest assistant message
      const messages = msgData.messages || msgData.data || [];
      const assistantMsg = messages.find((msg) => msg.role === 'assistant');

      if (!assistantMsg) {
        throw new Error('No assistant response found');
      }

      // Extract the text content and annotations
      let textContent = '';
      let annotations = [];

      if (assistantMsg.content && assistantMsg.content[0]) {
        if (assistantMsg.content[0].text) {
          textContent = assistantMsg.content[0].text.value || '';
          annotations = assistantMsg.content[0].text.annotations || [];
        } else if (typeof assistantMsg.content[0] === 'string') {
          textContent = assistantMsg.content[0];
        }
      } else if (typeof assistantMsg.content === 'string') {
        textContent = assistantMsg.content;
      }

      // Try to parse as JSON first
      try {
        const parsedContent = JSON.parse(textContent);
        const sources = this.processAnnotations(annotations);
        return {
          ...parsedContent,
          sources: sources
        };
      } catch {
        // If not JSON, return as plain text
        return {
          main_answer: textContent || assistantMsg.content,
          sources: []
        };
      }
    },
    processAnnotations(annotations) {
      const sources = [];
      annotations.forEach(annotation => {
        if (annotation.type === 'file_citation' && annotation.file_citation) {
          const fileId = annotation.file_citation.file_id;
          const fileDetails = websiteFiles.lookup(fileId);
          if (fileDetails) {
            sources.push({
              citation: annotation.text,
              fileId: fileId,
              url: fileDetails.source,
              title: fileDetails.title,
              filename: fileDetails.filename
            });
          } else {
            sources.push({
              citation: annotation.text,
              fileId: fileId,
              url: '#',
              title: 'Unknown source',
              filename: 'Unknown file'
            });
          }
        }
      });
      // Remove duplicates based on fileId
      const uniqueSources = sources.filter((source, index, self) =>
        index === self.findIndex((s) => s.fileId === source.fileId)
      );
      return uniqueSources;
    },
    extractCodeBlock(md, lang) {
      // Try markdown code block first
      const regex = new RegExp("```" + lang.toLowerCase() + "\\n([\\s\\S]*?)```", "i");
      const match = md.match(regex);
      if (match && match[1]) {
        return match[1].trim();
      }
      // Fallback: extract any markdown code block
      const genericMatch = md.match(/```[\w]*\n([\s\S]*?)```/);
      if (genericMatch && genericMatch[1]) {
        return genericMatch[1].trim();
      }
      // Fallback: extract from <pre><code>...</code></pre>
      const htmlMatch = md.match(/<pre><code>([\s\S]*?)<\/code><\/pre>/i);
      if (htmlMatch && htmlMatch[1]) {
        return htmlMatch[1]
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&amp;/g, '&')
          .replace(/&#10;/g, '\n')
          .replace(/&#13;/g, '\r')
          .trim();
      }
      return '';
    },
    copyToClipboard(code) {
      navigator.clipboard.writeText(code).then(() => {
        alert('Code copied to clipboard!');
      }, () => {
        alert('Failed to copy code.');
      });
    },
    parseRawPaste() {
      const raw = this.rawPaste;

      // Try to extract code from <pre><code>...</code></pre>
      let codeBlock = '';
      const codeMatch = raw.match(/<pre><code>([\s\S]*?)<\/code><\/pre>/i);
      if (codeMatch && codeMatch[1]) {
        // Replace HTML entities and <br> tags with real line breaks
        codeBlock = codeMatch[1]
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&amp;/g, '&')
          .replace(/&#10;/g, '\n')
          .replace(/&#13;/g, '\r');
      } else {
        // Fallback: try markdown code block extraction
        codeBlock = this.extractCodeBlock(raw, this.selectedLanguage);
      }

      this.messages.push({
        role: 'assistant',
        code: codeBlock,
        language: this.selectedLanguage,
        sources: [],
        content: raw
      });
      this.rawPaste = '';
    },
  },
  mounted() {
    // Populate the prompt textbox on initial load
    this.updatePrompt();
  }
};
</script>

<style scoped>
.card-body pre {
  background-color: #f8f9fa;
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  overflow-x: auto;
}

/* Style for citation links */
.card-body :deep(a sup) {
  font-size: 0.75rem;
  color: #0066cc;
  font-weight: 600;
}

.card-body :deep(a:hover sup) {
  color: #0052a3;
  text-decoration: underline;
}

/* Style for formatted content */
.formatted-content :deep(p) {
  margin-bottom: 1rem;
}

.formatted-content :deep(ol) {
  margin-bottom: 1rem;
}

.formatted-content :deep(li) {
  margin-bottom: 0.5rem;
}

.formatted-content :deep(code) {
  background-color: #f8f9fa;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  color: #e83e8c;
}
</style>
